export function formUniqueId() {
  return Date.now().toString() + "-" + Math.random().toString();
}
